export default {
	account: '账户名',
	'Ali iconcont Icon': '阿里 Iconfont 图标',
	array: '数组',
	ArrayKey: '键名',
	ArrayValue: '键值',
	Breakdown: '细目',
	checkbox: '复选框',
	choice: '选择',
	'city select': '城市选择',
	'Clean up all cache': '一键清理所有',
	'Clean up browser cache': '清理浏览器缓存',
	'Clean up system cache': '清理系统缓存',
	close: '关闭',
	color: '颜色',
	'color picker': '颜色选择器',
	comma: '，',
	date: '日期',
	Dict: '字典数据',
	email: '邮箱地址',
	Extend: '扩展属性',
	'Extended properties of Input, one line without quotation marks, such as: size=large': 'Input 的扩展属性，一行一个，无需引号，比如：size=large',
	file: '文件',
	float: '浮点数',
	'good afternoon': '下午好！',
	'Good evening': '晚上好！',
	'good morning!': '早上好！',
	'Good morning!': '上午好！',
	'Good noon!': '中午好！',
	'Hello!': '您好！',
	Icon: '图标',
	'icon select': '图标选择',
	'Id number': '身份证号',
	image: '图片',
	integer: '整数',
	items: '项',
	'Last upload time': '最后上传时间',
	'Late at night, pay attention to your body!': '夜深了，注意身体哦！',
	Loading: '加载中...',
	'Local icon title': '本地图标:/src/assets/icons中的.svg',
	mobile: '手机号',
	'multi image': '多图',
	Name: '名',
	'No data': '无数据',
	number: '数字',
	'One attribute per line without quotation marks(formitem)': 'FormItem 的扩展属性，一行一个，无需引号，比如：class=config-item',
	'One line at a time, without quotation marks, for example: key1=value1': '一行一个，无需引号，比如：key1=value1',
	open: '开启',
	'Original name': '原始名称',
	password: '密码',
	'Please install editor': '请先于模块市场安装富文本编辑器。',
	'Please select an icon': '请选择图标',
	preview: '预览',
	radio: '单选框',
	Reload: '重新加载',
	'remote select': '远程下拉',
	'rich Text': '富文本',
	Rule: '验证规则',
	select: '下拉框',
	'Select File': '选择文件',
	size: '大小',
	string: '字符串',
	switch: '开关',
	textarea: '多行文本框',
	'The data of the uploaded file is incomplete!': '上传文件的资料不完整！',
	'The moving position is beyond the movable range!': '移动位置超出了可移动范围！',
	'The size of the uploaded file exceeds the allowed range!': '上传文件的大小超出允许范围！',
	'The type of uploaded file is not allowed!': '上传文件的类型不被允许！',
	time: '时间',
	'time date': '时间日期',
	Tip: '提示信息',
	Title: '标题',
	type: '类型',
	'Upload (Reference) times': '上传(引用)次数',
	Var: '变量',
	'variable name': '变量名',
	'welcome back': '欢迎回来！',
	year: '年份',
	'You can also select': '还可以选择',
	'导航失败，菜单类型无法识别！': '导航失败，菜单类型无法识别！',
	'导航失败，导航守卫拦截！': '导航失败，导航守卫拦截！',
	'导航失败，路由无效！': '导航失败，路由无效！',
	'导航失败，已在导航目标位置！': '导航失败，已在导航目标位置！',
	'没有找到可以跳转的子级菜单！': '没有找到可以跳转的子级菜单！',
	清除成功: '清除成功',
}
